import { resetPasswordApi } from "@/api/services/main/auth";
import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { resetPasswordSchema } from "@/features/auth/schema/resetPasswordSchema";
import { TResetPasswordForm } from "@/features/auth/types/resetPasswordForm";
import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { AppRoutes } from "@/routes/config";
import { setErrorForm, showError } from "@/utils/error";
import { getQueryFromURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const initForm: TResetPasswordForm = {
  email: "",
  newPassword: "",
  confirmNewPassword: "",
  companyCode: "",
};

export const ResetPasswordForm = () => {
  const query = getQueryFromURL<TResetPasswordQuery>();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const methods = useForm<TResetPasswordForm>({
    mode: "all",
    reValidateMode: "onBlur",
    defaultValues: { ...initForm, email: query?.email ?? "", companyCode: query?.companyCode ?? "" },
    resolver: yupResolver(resetPasswordSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TResetPasswordForm) => {
    const { newPassword } = data;
    if (!query) return;
    const { email, resetToken, companyCode } = query;
    try {
      if (email && resetToken) {
        await resetPasswordApi({ email, newPassword, resetToken, companyCode });
        navigate(AppRoutes.resetPasswordComplete);
      }
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  const isRegisterRoute = pathname === AppRoutes.register;

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={resetPasswordSchema}>
      <Stack gap={3} width={400}>
        <FormField control={control} name="companyCode">
          <Input disabled size="lg" />
        </FormField>
        <FormField control={control} name="email">
          <Input disabled size="lg" />
        </FormField>
        <FormField control={control} name="newPassword">
          <Input type="password" size="lg" />
        </FormField>
        <FormField control={control} name="confirmNewPassword">
          <Input type="password" size="lg" />
        </FormField>
        <Typography variant="body14" color={"#5A6063"}>
          ※パスワードはアルファベット大文字・小文字・数字・記号を含む12文字以上で入力してください。
        </Typography>
        <Button type="submit" variant="primary" fullWidth>
          {isRegisterRoute ? "登録" : "パスワードを再発行"}
        </Button>
      </Stack>
    </Form>
  );
};
